import { DrugFactory } from './drugFactory';

import type { DrugEntity, DrugPropsPvt, DrugPropsPub } from './drugEntity';
import type { DrugIRepository } from './drugIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { DrugJsonPvt, DrugJsonPub } from '@/types/domain/drug/entities/drugEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class DrugRepository extends AppsyncRepository<
  DrugEntity,
  DrugPropsPvt,
  DrugJsonPvt,
  DrugPropsPub,
  DrugJsonPub
> implements DrugIRepository {
  private factory = new DrugFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppDrugDrugEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
